//import libraries
import { Injectable } from '@angular/core';
// import { Http, Headers, RequestOptions, URLSearchParams, Response, ResponseOptions} from '@angular/http';

import { Observable } from 'rxjs';

import { Resolve } from '@angular/router';
import { HttpClient,HttpResponse, HttpHeaders, HttpParams } from "@angular/common/http";


//import constants
import { AppSettings } from '../constants/app-settings';
import { AppBackRoutes } from '../constants/app-back-routes';

//import classes
import {
    NotificationGeneralGet
} from '../classes/notification.model';



//import language
import { MedicalGeneralLang,MedicalListLang } from '../languages/Medical.Lang';

//import services
import { GeneralService } from '../services/general.service';


@Injectable()

export class MedicalService implements Resolve<Observable<any>>{

    constructor(
        private http: HttpClient,
        private generalService: GeneralService,

    ) { }
    

    resolve() {
        return this.getList();
    }

    FetchDetails(exam_id = ""): Observable<any> {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.MedicalGeneralGet+"/"+exam_id;
        return this.http.get<any>(url);
    }

    newInterventionGet(exam_id){
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.NewInterventionGet+"/"+exam_id;
        return this.http.get<any>(url);
    }

  
    getList(){

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.medicalExamination;
        return this.http.get<any>(url);

    }

    listLang(details: any) {

        if (!details) return;

        let instance = new MedicalListLang(details.data.language, {});
        return instance.lang();

    }

    detailListLang(details: any) {

        if (!details) return;

        let instance = new MedicalListLang(details.data.language,details.data.new_lang_data);
        return instance.lang();

    }    

    GeneralGetLangData(details: any) {

        if (!details) return;

        let instance = new MedicalGeneralLang(details.data.language);
        return instance.lang();

    }

    update(data: any)
    {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.NotificationCreate;
        return this.http.post<any>(url, data);
    }

    update_exam(data: any,ID)
    {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.ExaminationUpdate+"/"+ID;
        return this.http.post<any>(url, data);
    }

    addExamination(data)
    {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.ExaminationCreate;
        return this.http.post<any>(url, data);
    }


    newExamination()
    {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.newExamination;
        return this.http.get<any>(url);
    }

    editExaminationGet(id){
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.editExaminationGet+"/"+id;
        return this.http.get<any>(url);        
    }


    delete_intervention(exam_id: any,intervention_id:any)
    {
        let data = { 'exam_id': exam_id, 'intervention_id':intervention_id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.MedicalInterventionDelete;
        return this.http.post<any>(url, data);

    }    

    delete(id: any)
    {
        let data = { 'eid': id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.MedicalDelete;
        return this.http.post<any>(url, data);

    }

    multiDelete(ids: any) {
        let data = { 'id': ids };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.MedicalMultiDelete;
        return this.http.post<any>(url, data);
    }

    multiDuplicate(ids: any) {
        let data = { 'id': ids };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.MedicalMultiDuplicate;
        return this.http.post<any>(url, data);
    }


    updateProfile(profileImage: any){

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.MedicaluploadExcel;
 
         let headers = new HttpHeaders({
             'Content-Type': 'application/json'
          });
 
         let options = {
             headers: headers
          }
 
         let data = {'profile' : profileImage};
          return this.http.post<any>(url, data, options);
 
    }
    
    view(id: any) {

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.notificationView + '/' + id;
        return this.http.get<any>(url);

    }

    viewdelete(id: any,cid: any,eid: any)
    {
        let data = { 'id': id, 'cid' : cid, eid : eid };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.NotificationViewDelete;
        return this.http.post<any>(url, data);

    }

    addpeople(data: any)
    {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.NotificationAddPeople;
        return this.http.post<any>(url, data);

    }

    send_notification(data: any)
    {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.NotificationSendmails;
        return this.http.post<any>(url, data);

    }

    sendInterventionMail(data){
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.NotificationInterventionMail;
        return this.http.post<any>(url, data);        
    }    

    updateOccurrence(data){
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.MedicalOccurenceUpdate;
        return this.http.post<any>(url, data);        
    }   

}